module.exports = __webpack_public_path__ + "img/LT112046953.b7dab79b.png";